import { useContext, useEffect } from "react"
import { Form } from "antd"
import { P } from "../../../../auth/permissions"
import BaseButton from "../../../../components/elements/BaseButton"
import BaseInputArea from "../../../../components/elements/BaseInputArea"
import BaseInputField from "../../../../components/elements/BaseInputField"
import BaseSelection from "../../../../components/elements/BaseSelection"
import { useAbility } from "../../../../components/contexts/AbilityContext"
import { ModalContext } from "../../../../components/contexts/ModalContext"
import BaseModal from "../../../../components/layout/BaseModal"
import { CostCenterType } from "../../../Mitarbeiter/types/Types"
import { Customer } from "../../../Kunden/types/Types"
import { ObjectType } from "../../types/types"
import ObjectDetailPartLeftCustomer from "./ObjectDetailPartLeftCustomer"

export const EDIT_OBJECT_MASTER_DATA_MODAL_ID = 12

type EditObjectMasterDataModalType = {
    objectData: ObjectType
    setobjectData: (e: any) => void
    costCenterData?: CostCenterType[]
    onSave: () => void
    onCancel: () => void
    customerOfObject: string
    customerData: Customer[]
    searchTermCustomer?: string
    setsearchTermCustomer: (e: any) => void
}

export default function EditObjectMasterDataModal(props: EditObjectMasterDataModalType) {
    const ability = useAbility()
    const modalCon = useContext(ModalContext)
    const [form] = Form.useForm()
    const info = props.objectData.objectInfo

    useEffect(() => {
        form.setFieldsValue({
            costcenter: props.costCenterData?.find((item) => item._id === props.objectData.costCenter)?.name ?? "",
            street: props.objectData.adress?.street,
            nr: props.objectData.adress?.nr,
            plz: props.objectData.adress?.plz,
            city: props.objectData.adress?.city,
            objectIndication: props.objectData.objectIndication,
        })
    }, [form, props.costCenterData, props.objectData])

    const updateInfo = (patch: Partial<NonNullable<ObjectType["objectInfo"]>>) =>
        props.setobjectData((prev: ObjectType) => ({
            ...prev,
            objectInfo: { ...prev.objectInfo, ...patch },
        }))

    return (
        <Form form={form} onFinish={props.onSave}>
            <BaseModal
                modalId={EDIT_OBJECT_MASTER_DATA_MODAL_ID}
                title="Stammdaten"
                onClose={props.onCancel}
                bottomRow={
                    <div className="flex justify-end gap-2">
                        <BaseButton
                            label="Abbrechen"
                            func={() => {
                                props.onCancel()
                                if (modalCon?.open) modalCon.trigger(0)
                            }}
                            variant="ghost"
                            size="small"
                            type="button"
                        />
                        <BaseButton label="Speichern" func={() => undefined} type="submit" colorway="secondary" size="small" />
                    </div>
                }>
                <div className="flex flex-col gap-1 py-4 pr-2">
                    <Form.Item className="mb-2" name={"objectIndication"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                        <BaseInputField
                            label={"Objektbezeichnung *"}
                            type={"text"}
                            value={props.objectData.objectIndication}
                            onChange={(e: string) => props.setobjectData((prev: ObjectType) => ({ ...prev, objectIndication: e }))}
                        />
                    </Form.Item>
                    <div className="flex flex-row gap-4 pt-2">
                        <Form.Item className="mb-2 w-2/3" name={"street"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                            <BaseInputField
                                label={"Straße *"}
                                type={"text"}
                                value={props.objectData.adress?.street}
                                onChange={(e: string) =>
                                    props.setobjectData((prev: ObjectType) => ({ ...prev, adress: { ...prev.adress, street: e } }))
                                }
                            />
                        </Form.Item>
                        <Form.Item className="mb-2 w-1/3" name={"nr"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                            <BaseInputField
                                label={"Nummer *"}
                                type={"text"}
                                value={props.objectData.adress?.nr}
                                onChange={(e: string) => props.setobjectData((prev: ObjectType) => ({ ...prev, adress: { ...prev.adress, nr: e } }))}
                            />
                        </Form.Item>
                    </div>
                    <div className="flex flex-row gap-4 pt-2">
                        <Form.Item className="mb-2 w-1/3" name={"plz"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                            <BaseInputField
                                label={"PLZ *"}
                                type={"text"}
                                value={props.objectData.adress?.plz}
                                onChange={(e: string) => props.setobjectData((prev: ObjectType) => ({ ...prev, adress: { ...prev.adress, plz: e } }))}
                            />
                        </Form.Item>
                        <Form.Item className="mb-2 w-2/3" name={"city"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                            <BaseInputField
                                label={"Stadt *"}
                                type={"text"}
                                value={props.objectData.adress?.city}
                                onChange={(e: string) => props.setobjectData((prev: ObjectType) => ({ ...prev, adress: { ...prev.adress, city: e } }))}
                            />
                        </Form.Item>
                    </div>
                    <ObjectDetailPartLeftCustomer
                        searchTerm={props.searchTermCustomer}
                        customer={props.customerData}
                        customerOfObject={props.customerOfObject}
                        setobjectData={props.setobjectData}
                        setsearchTermCustomer={props.setsearchTermCustomer}
                    />
                    <Form.Item className="mb-2" name={"costcenter"} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                        <BaseSelection
                            disabled={!ability.can(P.niederlassungen_read_write.action, P.niederlassungen_read_write.subject)}
                            classProps="pt-2"
                            placeholder={""}
                            label={"Niederlassung"}
                            value={props.costCenterData?.find((item) => item._id === props.objectData.costCenter)?.name ?? ""}
                            data={props.costCenterData?.map((item) => item.name) ?? []}
                            setId={(newItem: string) => {
                                const id = props.costCenterData?.find((item) => newItem === item.name)?._id
                                props.setobjectData((prev: ObjectType) => ({ ...prev, costCenter: id ?? prev.costCenter }))
                            }}
                        />
                    </Form.Item>
                    <div className="flex items-center gap-3 pt-2 pb-2">
                        <input
                            type="radio"
                            name="object-ranking"
                            value={1}
                            className="radio radio-success"
                            checked={props.objectData.ranking === 1}
                            onChange={() => props.setobjectData((prev: ObjectType) => ({ ...prev, ranking: 1 }))}
                        />
                        <input
                            type="radio"
                            name="object-ranking"
                            value={2}
                            className="radio radio-warning"
                            checked={props.objectData.ranking === 2}
                            onChange={() => props.setobjectData((prev: ObjectType) => ({ ...prev, ranking: 2 }))}
                        />
                        <input
                            type="radio"
                            name="object-ranking"
                            value={3}
                            className="radio radio-error"
                            checked={props.objectData.ranking === 3}
                            onChange={() => props.setobjectData((prev: ObjectType) => ({ ...prev, ranking: 3 }))}
                        />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 pt-2">
                        <BaseInputField
                            label={"Einheiten pro Eingang"}
                            type={"number"}
                            value={info?.unitperentrance}
                            onChange={(e: string) => updateInfo({ unitperentrance: Number(e) })}
                        />
                        <BaseInputField label={"Gesamt"} type={"number"} value={info?.amount} onChange={(e: string) => updateInfo({ amount: Number(e) })} />
                        <BaseInputField
                            label={"Grundstücksfläche in m²"}
                            type={"number"}
                            value={info?.propertyArea}
                            onChange={(e: string) => updateInfo({ propertyArea: Number(e) })}
                        />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 pt-2">
                        <BaseInputField
                            label={"Vertragsbeginn"}
                            type={"date"}
                            value={info?.contractStart}
                            onChange={(e: string) => updateInfo({ contractStart: e })}
                        />
                        <BaseInputField label={"Vertragsende"} type={"date"} value={info?.contractEnd} onChange={(e: string) => updateInfo({ contractEnd: e })} />
                        <BaseInputField
                            label={"Letzte Preisanpassung"}
                            type={"date"}
                            value={info?.lastPriceChange}
                            onChange={(e: string) => updateInfo({ lastPriceChange: e })}
                        />
                        <BaseInputField
                            label={"Letzte Vertragsänderung"}
                            type={"date"}
                            value={info?.lastContractChange}
                            onChange={(e: string) => updateInfo({ lastContractChange: e })}
                        />
                    </div>
                    <BaseInputArea label={"Bemerkung"} classProps="pt-2" value={info?.notes} onChange={(e: string) => updateInfo({ notes: e })} />
                </div>
            </BaseModal>
        </Form>
    )
}
